import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';
import Vue from 'vue'

const getDefaultStateForAssetClassifications = () => {
    return {
        asset_classifications:[],
        asset_classification_data:{},
        filter:{
            keyword:"",
            active_only:"1"
        },
        is_created:null,
        is_updated:null,
        is_deleted:null
    }
}

// state
const state = getDefaultStateForAssetClassifications()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_ASSET_CLASSIFICATIONS (state) {
        Object.assign(state, getDefaultStateForAssetClassifications())
    },
    SET_ASSET_CLASSIFICATIONS(state, data){
        state.asset_classifications = data
    },
    SET_ACCOUNT_ITEMS(state, data){
        state.account_items = data
    },
    FETCH_ALL(state, data){
        state.asset_classifications = data
    },
    FETCH(state, data){
      state.asset_classification_data = data
    },
    SET_IS_DELETED(state, data){
        state.is_deleted = data
    },
    SET_IS_CREATED(state, data){
        state.is_created = data
    },
    SET_IS_UPDATED(state, data){
        state.is_updated = data
    },
    QUICK_SEARCH(state, data){
      state.asset_classifications = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    FETCH(state, data)
    {
        state.asset_classification_data = data
    }
}

// actions
const actions = {
    resetState({ commit }, payload) {
        commit("RESET_STATE_FOR_ASSET_CLASSIFICATIONS")
    },
    fetch({ commit }, data) {
        return axios.post(apiRoutes['ASSET_CLASSIFICATIONS_RETRIEVE'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH', response.data.data)
              } else {
                commit('FETCH', {})
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['ASSET_CLASSIFICATIONS_CREATE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Asset Classification has been created",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                commit("SET_IS_CREATED", 1)

            }
            else
            {
                let errors = response.data.data.errors
                commit("SET_IS_CREATED", 0)

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 3000,
                    speed: 300
                })
                }
            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 3000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Asset Classification")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['ASSET_CLASSIFICATIONS_UPDATE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: "Asset Classification has been updated",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                commit("SET_IS_UPDATED", 1)

            }
            else
            {
                let errors = response.data.data.errors
                commit("SET_IS_UPDATED", 0)
                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application exception")
              }
          });
    },
    async delete({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['DELETE_PRODUCT_CODE'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                  let id  = response.data.data
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Product Code has been deleted",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  //dispatch("customers/fetch", {"code":data.contact_code}, {root:true})
                 // commit("SET_BANK_ACCOUNT_ID", id)
                 commit("SET_IS_DELETED", 1)
  
              }
              else
              {
                  let errors = response.data.data.errors
  
                  if(Array.isArray(errors))
                  {
                    console.log(errors)
                    let msg = errors.join("\n")
  
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
  
              }
  
            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)
  
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    //console.log("Problem submitting New Post", error);
                    alert("Application exception")
                }
            });
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['ASSET_CLASSIFICATIONS_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('QUICK_SEARCH', response.data.data)
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('QUICK_SEARCH', [])
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem submitting New Customer", error);
              }
          });
    },
    async listAccountItems({ commit }, data) {
        return axios.post(apiRoutes['LIST_ACCOUNT_ITEMS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('SET_ACCOUNT_ITEMS', response.data.data)
              } 
              else 
              {
                commit('SET_ACCOUNT_ITEMS', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem querying data", error);
              }
          });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
